module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/2@2x_da5a8a9b9d86f05cf763ade0b61ae680.png";